<script setup lang="ts">
import { computed } from 'vue'
import { QUARTER_NUMBERS, type ObjectiveLevel } from './objective_levels'

const props = withDefaults(
  defineProps<{
    level: ObjectiveLevel
    title?: string
  }>(),
  { title: 'Measurable Objective' }
)

defineSlots<{
  default(): unknown
}>()

const quarterNumber = computed(() => QUARTER_NUMBERS[props.level])
</script>

<template>
  <div class="mb-4 w-full text-text-xl leading-relaxed text-gray-900" data-testid="accordion-objective">
    <span class="text-text-sm font-medium uppercase text-gray-700">Quarter {{ quarterNumber }}</span>
    <h3 class="mb-2.5 mt-0 text-text-xl font-bold leading-5 text-gray-900">{{ title }}</h3>
    <slot />
  </div>
</template>
